import React from "react";
// ##### 23-11-02 Komarov
import { Media } from "../../../helpers/MediaConfig";

// ##### 24-04-05 Komarov
const SvgTag = ({ width }) => (
  <svg
    data-component="Hotels"
    version="1.0"
    /* width="510.79999pt"
  height="511.04553pt"
  viewBox="0 0 510.79999 511.04553" */
    width={width}
    viewBox="0 0 576 512"
    preserveAspectRatio="xMidYMid"
    id="svg2"
    sodipodi:docname="Hotel_00_Dark_Blue.svg"
    inkscape:version="1.3 (0e150ed6c4, 2023-07-21)"
    xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape"
    xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:svg="http://www.w3.org/2000/svg"
  >
    <defs id="defs2" />
    <sodipodi:namedview
      id="namedview2"
      pagecolor="#ffffff"
      bordercolor="#000000"
      borderopacity="0.25"
      inkscape:showpageshadow="2"
      inkscape:pageopacity="0.0"
      inkscape:pagecheckerboard="0"
      inkscape:deskcolor="#d1d1d1"
      inkscape:document-units="pt"
      inkscape:zoom="0.52722268"
      inkscape:cx="527.29143"
      inkscape:cy="289.25159"
      inkscape:window-width="1366"
      inkscape:window-height="705"
      inkscape:window-x="-8"
      inkscape:window-y="-8"
      inkscape:window-maximized="1"
      inkscape:current-layer="svg2"
    />
    <g
      transform="matrix(0.1,0,0,-0.1,-0.6,511.64552)"
      fill="#000000"
      stroke="none"
      id="g2"
      style={{
        fill: "#000080",
      }}
    >
      <path
        d="m 2380,5114 c -19,-2 -78,-9 -130,-14 -330,-36 -695,-160 -990,-336 C 885,4540 580,4235 356,3860 181,3568 65,3228 18,2870 2,2747 2,2373 18,2250 100,1627 374,1100 838,669 1094,430 1413,244 1760,130 2034,39 2251,6 2560,6 c 228,0 329,9 530,50 689,141 1304,583 1674,1204 175,292 291,632 338,990 16,123 16,497 0,620 -47,358 -163,698 -338,990 -224,375 -529,680 -904,904 -289,173 -634,291 -980,336 -88,12 -438,21 -500,14 z m 432,-640 c 430,-59 808,-246 1112,-550 248,-249 422,-552 506,-884 99,-392 74,-810 -69,-1177 C 4205,1464 3915,1121 3550,903 3106,638 2586,563 2080,690 1543,826 1079,1203 826,1708 628,2103 578,2594 690,3040 c 136,537 513,1001 1018,1254 320,161 746,230 1104,180 z"
        id="path1"
        style={{
          fill: "#000080",
        }}
      />
      <path
        d="M 1450,2560 V 1520 h 310 310 l 2,363 3,362 h 485 485 l 3,-362 2,-363 h 310 310 v 1040 1040 h -310 -310 l -2,-362 -3,-363 h -485 -485 l -3,363 -2,362 h -310 -310 z"
        id="path2"
        style={{
          fill: "#000080",
        }}
      />
    </g>
  </svg>
);

// ##### 24-04-05 Komarov
export const Hotels = () => (
  <>
    <Media lessThan="Laptop-1024-1440">
      <SvgTag width="20" />
    </Media>
    <Media greaterThanOrEqual="Laptop-1024-1440">
      <SvgTag width="25%" />
    </Media>
  </>
);

// ##### 24-04-05 Komarov
export const HotelsAutocompleteItemRequest = () => (
  <svg
    data-component="HotelsAutocompleteItemRequest"
    // color='#003057'
    // width="20"
    width="25"
    height="20"
    aria-hidden="true"
    focusable="false"
    data-prefix="fas"
    data-icon="hotel"
    className="svg-inline--fa fa-hotel fa-w-18"
    role="img"
    xmlns="http://www.w3.org/2000/svg"
    // viewBox="0 0 576 512"
    //  viewBox="0 0 680 512"
    viewBox="0 0 707.77069 511.04553"
    preserveAspectRatio="xMidYMid"
    id="svg2"
    sodipodi:docname="Hotel_Quest_07.svg"
    inkscape:version="1.3 (0e150ed6c4, 2023-07-21)"
    xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape"
    xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd"
  >
    <defs id="defs2" />
    <sodipodi:namedview
      id="namedview2"
      pagecolor="#ffffff"
      bordercolor="#000000"
      borderopacity="0.25"
      inkscape:showpageshadow="2"
      inkscape:pageopacity="0.0"
      inkscape:pagecheckerboard="0"
      inkscape:deskcolor="#d1d1d1"
      inkscape:document-units="pt"
      inkscape:zoom="0.52722268"
      inkscape:cx="498.84045"
      inkscape:cy="291.14832"
      inkscape:window-width="1366"
      inkscape:window-height="705"
      inkscape:window-x="-8"
      inkscape:window-y="-8"
      inkscape:window-maximized="1"
      inkscape:current-layer="svg2"
    />
    <g
      transform="matrix(0.1,0,0,-0.1,-0.6,511.64552)"
      fill="#000000"
      stroke="none"
      id="g2"
      style={{ fill: "#c87137" }}
    >
      <path
        d="m 2380,5114 c -19,-2 -78,-9 -130,-14 -330,-36 -695,-160 -990,-336 C 885,4540 580,4235 356,3860 181,3568 65,3228 18,2870 2,2747 2,2373 18,2250 100,1627 374,1100 838,669 1094,430 1413,244 1760,130 2034,39 2251,6 2560,6 c 228,0 329,9 530,50 689,141 1304,583 1674,1204 175,292 291,632 338,990 16,123 16,497 0,620 -47,358 -163,698 -338,990 -224,375 -529,680 -904,904 -289,173 -634,291 -980,336 -88,12 -438,21 -500,14 z m 432,-640 c 430,-59 808,-246 1112,-550 248,-249 422,-552 506,-884 99,-392 74,-810 -69,-1177 C 4205,1464 3915,1121 3550,903 3106,638 2586,563 2080,690 1543,826 1079,1203 826,1708 628,2103 578,2594 690,3040 c 136,537 513,1001 1018,1254 320,161 746,230 1104,180 z"
        id="path1"
        style={{ fill: "#c87137" }}
      />
      <path
        d="M 1450,2560 V 1520 h 310 310 l 2,363 3,362 h 485 485 l 3,-362 2,-363 h 310 310 v 1040 1040 h -310 -310 l -2,-362 -3,-363 h -485 -485 l -3,363 -2,362 h -310 -310 z"
        id="path2"
        style={{ fill: "#c87137" }}
      />
    </g>
    <g
      transform="matrix(0.38488971,0,0,-0.38488971,-435.92121,625.45497)"
      fill="#000000"
      stroke="none"
      id="g2-9"
      style={{
        fill: "#ff7300",
        fillOpacity: 1,
      }}
    >
      <path
        d="m 2553.5406,893.89103 c -9.023,0.029 -18.0176,-0.3379 -26.9532,-1.0986 -8.9355,-0.7608 -17.8091,-1.9212 -26.6015,-3.4571 -8.7925,-1.5358 -17.4952,-3.4453 -26.0889,-5.7421 -8.5937,-2.2969 -17.0757,-4.969 -25.415,-8.0127 -8.3394,-3.0437 -16.5362,-6.4629 -24.5655,-10.2393 -8.0293,-3.7764 -15.8911,-7.9124 -23.5546,-12.4072 -7.6636,-4.4949 -15.126,-9.3467 -22.3682,-14.5459 -7.2422,-5.1992 -14.27,-10.7512 -21.0352,-16.6406 -6.7651,-5.8894 -13.2793,-12.1114 -19.5117,-18.6768 -6.2324,-6.5654 -12.1831,-13.471 -17.8271,-20.6982 -5.6441,-7.2273 -10.9815,-14.7862 -15.9815,-22.6612 -3.0312,-4.75 -5.9068,-9.548 -8.6426,-14.3847 -2.7358,-4.8367 -5.3204,-9.706 -7.7636,-14.6192 -2.4433,-4.9132 -4.7459,-9.8593 -6.8994,-14.8389 -2.1536,-4.9795 -4.1685,-9.9936 -6.0352,-15.0292 -1.8667,-5.0357 -3.5882,-10.0943 -5.1709,-15.1758 -1.5827,-5.0816 -3.0197,-10.1903 -4.3213,-15.3076 -2.6033,-10.2347 -4.6562,-20.5333 -6.1523,-30.84966 -1.4961,-10.3164 -2.4446,-20.65016 -2.8565,-30.9668 -0.4118,-10.31664 -0.2832,-20.61427 0.3662,-30.84961 0.6494,-10.23534 1.8279,-20.4109 3.5157,-30.4834 1.6877,-10.0725 3.8886,-20.04005 6.5918,-29.86816 2.7031,-9.82812 5.8991,-19.51637 9.5947,-29.01856 3.6955,-9.50218 7.8887,-18.81055 12.5537,-27.90527 4.665,-9.09472 9.8132,-17.96656 15.4248,-26.57227 5.6116,-8.6057 11.6875,-16.95508 18.2227,-24.99023 6.5351,-8.03515 13.5261,-15.76148 20.9619,-23.14453 3.7179,-3.69153 7.5456,-7.29734 11.4843,-10.81055 3.9388,-3.51321 7.9869,-6.9292 12.1436,-10.2539 4.1567,-3.32471 8.4162,-6.55662 12.7881,-9.68262 4.3718,-3.126 8.8631,-6.15027 13.4472,-9.06738 4.5841,-2.91712 9.2691,-5.72483 14.0625,-8.42286 4.7935,-2.69802 9.6924,-5.28027 14.6924,-7.74902 7.25,-3.5625 14.6504,-6.80103 22.1778,-9.69726 7.5273,-2.89624 15.1748,-5.44923 22.9248,-7.69043 7.75,-2.24121 15.6074,-4.15943 23.5254,-5.75684 7.9179,-1.59741 15.9043,-2.8877 23.9355,-3.85254 8.0312,-0.96484 16.0947,-1.60474 24.1846,-1.94824 8.0898,-0.34351 16.208,-0.38379 24.3017,-0.11719 8.0938,0.2666 16.1709,0.83374 24.2139,1.69922 8.043,0.86548 16.042,2.0332 23.9795,3.48633 7.9375,1.45312 15.8066,3.19995 23.584,5.22949 7.7773,2.02954 15.4648,4.33399 23.0273,6.92871 7.5625,2.59473 15.002,5.47925 22.2949,8.62793 7.293,3.14868 14.4473,6.5625 21.4161,10.25391 6.9687,3.6914 13.7568,7.65698 20.3466,11.87988 6.5899,4.2229 12.9747,8.70411 19.1309,13.44727 6.1562,4.74315 12.0859,9.7478 17.7539,15 5.668,5.25219 11.0762,10.75879 16.2012,16.50878 6.625,7.625 12.7519,15.18654 18.3984,22.74903 5.6465,7.56249 10.8164,15.12403 15.5274,22.74902 4.7109,7.62499 8.955,15.30274 12.7734,23.11524 3.8184,7.81249 7.2119,15.75196 10.1807,23.87695 2.9687,8.12499 5.5136,16.44239 7.6757,25.00488 2.1621,8.56249 3.9336,17.37403 5.3321,26.49903 1.3984,9.12499 2.4277,18.56153 3.1054,28.37402 0.6778,9.81249 1.0108,20.00489 1.0108,30.62988 0,7.62499 -0.2234,15.13404 -0.6592,22.5293 -0.4358,7.39525 -1.0947,14.667 -1.9629,21.82617 -0.8682,7.15918 -1.9402,14.20628 -3.2373,21.12308 -1.2971,6.9167 -2.8184,13.708 -4.541,20.3759 -1.7227,6.668 -3.656,13.2161 -5.8008,19.629 -2.1448,6.4128 -4.4971,12.6865 -7.0605,18.8378 -2.5635,6.1514 -5.3416,12.178 -8.3203,18.0616 -2.9788,5.8835 -6.1602,11.6318 -9.5508,17.2412 -3.3907,5.6093 -6.9822,11.0774 -10.7813,16.4062 -3.799,5.3289 -7.8076,10.5147 -12.0117,15.5567 -4.2041,5.042 -8.6072,9.9436 -13.2129,14.6924 -4.6057,4.7487 -9.4102,9.3496 -14.4141,13.7988 -5.0039,4.4492 -10.2019,8.7473 -15.6005,12.8906 -5.3987,4.1433 -10.9971,8.1221 -16.7871,11.9531 -5.7901,3.8311 -11.7811,7.5179 -17.959,11.0303 -6.178,3.5125 -12.5391,6.8613 -19.1016,10.0488 -8.625,4.1875 -17.3608,7.9373 -26.1768,11.2647 -8.8159,3.3274 -17.7089,6.2344 -26.6601,8.7158 -8.9512,2.4814 -17.9663,4.532 -26.9971,6.1816 -9.0307,1.6497 -18.0889,2.8887 -27.1435,3.7207 -9.0547,0.8321 -18.106,1.2605 -27.1289,1.2891 z"
        style={{
          fill: "#ff7300",
          fillOpacity: 1,
          stroke: "none",
          strokeOpacity: 1,
        }}
        id="path4"
      />
    </g>
  </svg>
);

export const HotelsAutocompleteItemAllotment = () => (
  <svg
    data-component="HotelsAutocompleteItemAllotment"
    title="Hotel on allotment"
    version="1.0"
    width="25"
    height="20"
    // width="690.94067pt"
    // height="511.7746pt"
    viewBox="0 0 707.77069 511.04553"
    preserveAspectRatio="xMidYMid"
    id="svg2"
    sodipodi:docname="Hotel_Arrow_05.svg"
    inkscape:version="1.3 (0e150ed6c4, 2023-07-21)"
    xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape"
    xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:svg="http://www.w3.org/2000/svg"
  >
    <defs id="defs2" />
    <sodipodi:namedview
      id="namedview2"
      pagecolor="#ffffff"
      bordercolor="#000000"
      borderopacity="0.25"
      inkscape:showpageshadow="2"
      inkscape:pageopacity="0.0"
      inkscape:pagecheckerboard="0"
      inkscape:deskcolor="#d1d1d1"
      inkscape:document-units="pt"
      inkscape:zoom="0.52722268"
      inkscape:cx="527.29143"
      inkscape:cy="292.09669"
      inkscape:window-width="1366"
      inkscape:window-height="768"
      inkscape:window-x="0"
      inkscape:window-y="0"
      inkscape:window-maximized="0"
      inkscape:current-layer="svg2"
    />
    <g
      transform="matrix(0.1,0,0,-0.1,-0.6,511.64552)"
      fill="#000000"
      stroke="none"
      id="g2"
      style={{
        fill: "#800000",
      }}
    >
      <path
        d="m 2380,5114 c -19,-2 -78,-9 -130,-14 -330,-36 -695,-160 -990,-336 C 885,4540 580,4235 356,3860 181,3568 65,3228 18,2870 2,2747 2,2373 18,2250 100,1627 374,1100 838,669 1094,430 1413,244 1760,130 2034,39 2251,6 2560,6 c 228,0 329,9 530,50 689,141 1304,583 1674,1204 175,292 291,632 338,990 16,123 16,497 0,620 -47,358 -163,698 -338,990 -224,375 -529,680 -904,904 -289,173 -634,291 -980,336 -88,12 -438,21 -500,14 z m 432,-640 c 430,-59 808,-246 1112,-550 248,-249 422,-552 506,-884 99,-392 74,-810 -69,-1177 C 4205,1464 3915,1121 3550,903 3106,638 2586,563 2080,690 1543,826 1079,1203 826,1708 628,2103 578,2594 690,3040 c 136,537 513,1001 1018,1254 320,161 746,230 1104,180 z"
        id="path1"
        style={{
          fill: "#800000",
        }}
      />
      <path
        d="M 1450,2560 V 1520 h 310 310 l 2,363 3,362 h 485 485 l 3,-362 2,-363 h 310 310 v 1040 1040 h -310 -310 l -2,-362 -3,-363 h -485 -485 l -3,363 -2,362 h -310 -310 z"
        id="path2"
        style={{
          fill: "#800000",
        }}
      />
    </g>
    <g
      transform="matrix(0.38488971,0,0,-0.38488971,-433.35749,625.03929)"
      fill="#000000"
      stroke="none"
      id="g2-5"
      style={{
        fill: "#00ff00",
        fillOpacity: 1,
      }}
    >
      <path
        d="m 2553.5406,893.89103 c -9.023,0.029 -18.0176,-0.3379 -26.9532,-1.0986 -8.9355,-0.7608 -17.8091,-1.9212 -26.6015,-3.4571 -8.7925,-1.5358 -17.4952,-3.4453 -26.0889,-5.7421 -8.5937,-2.2969 -17.0757,-4.969 -25.415,-8.0127 -8.3394,-3.0437 -16.5362,-6.4629 -24.5655,-10.2393 -8.0293,-3.7764 -15.8911,-7.9124 -23.5546,-12.4072 -7.6636,-4.4949 -15.126,-9.3467 -22.3682,-14.5459 -7.2422,-5.1992 -14.27,-10.7512 -21.0352,-16.6406 -6.7651,-5.8894 -13.2793,-12.1114 -19.5117,-18.6768 -6.2324,-6.5654 -12.1831,-13.471 -17.8271,-20.6982 -5.6441,-7.2273 -10.9815,-14.7862 -15.9815,-22.6612 -3.0312,-4.75 -5.9068,-9.548 -8.6426,-14.3847 -2.7358,-4.8367 -5.3204,-9.706 -7.7636,-14.6192 -2.4433,-4.9132 -4.7459,-9.8593 -6.8994,-14.8389 -2.1536,-4.9795 -4.1685,-9.9936 -6.0352,-15.0292 -1.8667,-5.0357 -3.5882,-10.0943 -5.1709,-15.1758 -1.5827,-5.0816 -3.0197,-10.1903 -4.3213,-15.3076 -2.6033,-10.2347 -4.6562,-20.5333 -6.1523,-30.84966 -1.4961,-10.3164 -2.4446,-20.65016 -2.8565,-30.9668 -0.4118,-10.31664 -0.2832,-20.61427 0.3662,-30.84961 0.6494,-10.23534 1.8279,-20.4109 3.5157,-30.4834 1.6877,-10.0725 3.8886,-20.04005 6.5918,-29.86816 2.7031,-9.82812 5.8991,-19.51637 9.5947,-29.01856 3.6955,-9.50218 7.8887,-18.81055 12.5537,-27.90527 4.665,-9.09472 9.8132,-17.96656 15.4248,-26.57227 5.6116,-8.6057 11.6875,-16.95508 18.2227,-24.99023 6.5351,-8.03515 13.5261,-15.76148 20.9619,-23.14453 3.7179,-3.69153 7.5456,-7.29734 11.4843,-10.81055 3.9388,-3.51321 7.9869,-6.9292 12.1436,-10.2539 4.1567,-3.32471 8.4162,-6.55662 12.7881,-9.68262 4.3718,-3.126 8.8631,-6.15027 13.4472,-9.06738 4.5841,-2.91712 9.2691,-5.72483 14.0625,-8.42286 4.7935,-2.69802 9.6924,-5.28027 14.6924,-7.74902 7.25,-3.5625 14.6504,-6.80103 22.1778,-9.69726 7.5273,-2.89624 15.1748,-5.44923 22.9248,-7.69043 7.75,-2.24121 15.6074,-4.15943 23.5254,-5.75684 7.9179,-1.59741 15.9043,-2.8877 23.9355,-3.85254 8.0312,-0.96484 16.0947,-1.60474 24.1846,-1.94824 8.0898,-0.34351 16.208,-0.38379 24.3017,-0.11719 8.0938,0.2666 16.1709,0.83374 24.2139,1.69922 8.043,0.86548 16.042,2.0332 23.9795,3.48633 7.9375,1.45312 15.8066,3.19995 23.584,5.22949 7.7773,2.02954 15.4648,4.33399 23.0273,6.92871 7.5625,2.59473 15.002,5.47925 22.2949,8.62793 7.293,3.14868 14.4473,6.5625 21.4161,10.25391 6.9687,3.6914 13.7568,7.65698 20.3466,11.87988 6.5899,4.2229 12.9747,8.70411 19.1309,13.44727 6.1562,4.74315 12.0859,9.7478 17.7539,15 5.668,5.25219 11.0762,10.75879 16.2012,16.50878 6.625,7.625 12.7519,15.18654 18.3984,22.74903 5.6465,7.56249 10.8164,15.12403 15.5274,22.74902 4.7109,7.62499 8.955,15.30274 12.7734,23.11524 3.8184,7.81249 7.2119,15.75196 10.1807,23.87695 2.9687,8.12499 5.5136,16.44239 7.6757,25.00488 2.1621,8.56249 3.9336,17.37403 5.3321,26.49903 1.3984,9.12499 2.4277,18.56153 3.1054,28.37402 0.6778,9.81249 1.0108,20.00489 1.0108,30.62988 0,7.62499 -0.2234,15.13404 -0.6592,22.5293 -0.4358,7.39525 -1.0947,14.667 -1.9629,21.82617 -0.8682,7.15918 -1.9402,14.20628 -3.2373,21.12308 -1.2971,6.9167 -2.8184,13.708 -4.541,20.3759 -1.7227,6.668 -3.656,13.2161 -5.8008,19.629 -2.1448,6.4128 -4.4971,12.6865 -7.0605,18.8378 -2.5635,6.1514 -5.3416,12.178 -8.3203,18.0616 -2.9788,5.8835 -6.1602,11.6318 -9.5508,17.2412 -3.3907,5.6093 -6.9822,11.0774 -10.7813,16.4062 -3.799,5.3289 -7.8076,10.5147 -12.0117,15.5567 -4.2041,5.042 -8.6072,9.9436 -13.2129,14.6924 -4.6057,4.7487 -9.4102,9.3496 -14.4141,13.7988 -5.0039,4.4492 -10.2019,8.7473 -15.6005,12.8906 -5.3987,4.1433 -10.9971,8.1221 -16.7871,11.9531 -5.7901,3.8311 -11.7811,7.5179 -17.959,11.0303 -6.178,3.5125 -12.5391,6.8613 -19.1016,10.0488 -8.625,4.1875 -17.3608,7.9373 -26.1768,11.2647 -8.8159,3.3274 -17.7089,6.2344 -26.6601,8.7158 -8.9512,2.4814 -17.9663,4.532 -26.9971,6.1816 -9.0307,1.6497 -18.0889,2.8887 -27.1435,3.7207 -9.0547,0.8321 -18.106,1.2605 -27.1289,1.2891 z"
        style={{
          fill: "#00ff00",
          fillOpacity: 1,
          stroke: "none",
          strokeOpacity: 1,
        }}
        id="path4"
      />
    </g>
  </svg>
);

export const HotelsAutocompleteItem = () => (
  <svg
    data-component="HotelsAutocompleteItem"
    version="1.0"
    width="25"
    height="20"
    // width="690.94067pt"
    // height="511.7746pt"
    viewBox="0 0 707.77069 511.04553"
    preserveAspectRatio="xMidYMid"
    id="svg2"
    sodipodi:docname="Hotel_Arrow_05.svg"
    inkscape:version="1.3 (0e150ed6c4, 2023-07-21)"
    xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape"
    xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:svg="http://www.w3.org/2000/svg"
  >
    <defs id="defs2" />
    <sodipodi:namedview
      id="namedview2"
      pagecolor="#ffffff"
      bordercolor="#000000"
      borderopacity="0.25"
      inkscape:showpageshadow="2"
      inkscape:pageopacity="0.0"
      inkscape:pagecheckerboard="0"
      inkscape:deskcolor="#d1d1d1"
      inkscape:document-units="pt"
      inkscape:zoom="0.52722268"
      inkscape:cx="527.29143"
      inkscape:cy="292.09669"
      inkscape:window-width="1366"
      inkscape:window-height="768"
      inkscape:window-x="0"
      inkscape:window-y="0"
      inkscape:window-maximized="0"
      inkscape:current-layer="svg2"
    />
    <g
      transform="matrix(0.1,0,0,-0.1,-0.6,511.64552)"
      fill="#000000"
      stroke="none"
      id="g2"
      style={{
        fill: "#800000",
      }}
    >
      <path
        d="m 2380,5114 c -19,-2 -78,-9 -130,-14 -330,-36 -695,-160 -990,-336 C 885,4540 580,4235 356,3860 181,3568 65,3228 18,2870 2,2747 2,2373 18,2250 100,1627 374,1100 838,669 1094,430 1413,244 1760,130 2034,39 2251,6 2560,6 c 228,0 329,9 530,50 689,141 1304,583 1674,1204 175,292 291,632 338,990 16,123 16,497 0,620 -47,358 -163,698 -338,990 -224,375 -529,680 -904,904 -289,173 -634,291 -980,336 -88,12 -438,21 -500,14 z m 432,-640 c 430,-59 808,-246 1112,-550 248,-249 422,-552 506,-884 99,-392 74,-810 -69,-1177 C 4205,1464 3915,1121 3550,903 3106,638 2586,563 2080,690 1543,826 1079,1203 826,1708 628,2103 578,2594 690,3040 c 136,537 513,1001 1018,1254 320,161 746,230 1104,180 z"
        id="path1"
        style={{
          fill: "#800000",
        }}
      />
      <path
        d="M 1450,2560 V 1520 h 310 310 l 2,363 3,362 h 485 485 l 3,-362 2,-363 h 310 310 v 1040 1040 h -310 -310 l -2,-362 -3,-363 h -485 -485 l -3,363 -2,362 h -310 -310 z"
        id="path2"
        style={{
          fill: "#800000",
        }}
      />
    </g>
    <g
      transform="matrix(0.38488971,0,0,-0.38488971,-433.35749,625.03929)"
      fill="#000000"
      stroke="none"
      id="g2-5"
      style={{
        fill: "#00ff00",
        fillOpacity: 1,
      }}
    >
      <path
        d="m 2553.5406,893.89103 c -9.023,0.029 -18.0176,-0.3379 -26.9532,-1.0986 -8.9355,-0.7608 -17.8091,-1.9212 -26.6015,-3.4571 -8.7925,-1.5358 -17.4952,-3.4453 -26.0889,-5.7421 -8.5937,-2.2969 -17.0757,-4.969 -25.415,-8.0127 -8.3394,-3.0437 -16.5362,-6.4629 -24.5655,-10.2393 -8.0293,-3.7764 -15.8911,-7.9124 -23.5546,-12.4072 -7.6636,-4.4949 -15.126,-9.3467 -22.3682,-14.5459 -7.2422,-5.1992 -14.27,-10.7512 -21.0352,-16.6406 -6.7651,-5.8894 -13.2793,-12.1114 -19.5117,-18.6768 -6.2324,-6.5654 -12.1831,-13.471 -17.8271,-20.6982 -5.6441,-7.2273 -10.9815,-14.7862 -15.9815,-22.6612 -3.0312,-4.75 -5.9068,-9.548 -8.6426,-14.3847 -2.7358,-4.8367 -5.3204,-9.706 -7.7636,-14.6192 -2.4433,-4.9132 -4.7459,-9.8593 -6.8994,-14.8389 -2.1536,-4.9795 -4.1685,-9.9936 -6.0352,-15.0292 -1.8667,-5.0357 -3.5882,-10.0943 -5.1709,-15.1758 -1.5827,-5.0816 -3.0197,-10.1903 -4.3213,-15.3076 -2.6033,-10.2347 -4.6562,-20.5333 -6.1523,-30.84966 -1.4961,-10.3164 -2.4446,-20.65016 -2.8565,-30.9668 -0.4118,-10.31664 -0.2832,-20.61427 0.3662,-30.84961 0.6494,-10.23534 1.8279,-20.4109 3.5157,-30.4834 1.6877,-10.0725 3.8886,-20.04005 6.5918,-29.86816 2.7031,-9.82812 5.8991,-19.51637 9.5947,-29.01856 3.6955,-9.50218 7.8887,-18.81055 12.5537,-27.90527 4.665,-9.09472 9.8132,-17.96656 15.4248,-26.57227 5.6116,-8.6057 11.6875,-16.95508 18.2227,-24.99023 6.5351,-8.03515 13.5261,-15.76148 20.9619,-23.14453 3.7179,-3.69153 7.5456,-7.29734 11.4843,-10.81055 3.9388,-3.51321 7.9869,-6.9292 12.1436,-10.2539 4.1567,-3.32471 8.4162,-6.55662 12.7881,-9.68262 4.3718,-3.126 8.8631,-6.15027 13.4472,-9.06738 4.5841,-2.91712 9.2691,-5.72483 14.0625,-8.42286 4.7935,-2.69802 9.6924,-5.28027 14.6924,-7.74902 7.25,-3.5625 14.6504,-6.80103 22.1778,-9.69726 7.5273,-2.89624 15.1748,-5.44923 22.9248,-7.69043 7.75,-2.24121 15.6074,-4.15943 23.5254,-5.75684 7.9179,-1.59741 15.9043,-2.8877 23.9355,-3.85254 8.0312,-0.96484 16.0947,-1.60474 24.1846,-1.94824 8.0898,-0.34351 16.208,-0.38379 24.3017,-0.11719 8.0938,0.2666 16.1709,0.83374 24.2139,1.69922 8.043,0.86548 16.042,2.0332 23.9795,3.48633 7.9375,1.45312 15.8066,3.19995 23.584,5.22949 7.7773,2.02954 15.4648,4.33399 23.0273,6.92871 7.5625,2.59473 15.002,5.47925 22.2949,8.62793 7.293,3.14868 14.4473,6.5625 21.4161,10.25391 6.9687,3.6914 13.7568,7.65698 20.3466,11.87988 6.5899,4.2229 12.9747,8.70411 19.1309,13.44727 6.1562,4.74315 12.0859,9.7478 17.7539,15 5.668,5.25219 11.0762,10.75879 16.2012,16.50878 6.625,7.625 12.7519,15.18654 18.3984,22.74903 5.6465,7.56249 10.8164,15.12403 15.5274,22.74902 4.7109,7.62499 8.955,15.30274 12.7734,23.11524 3.8184,7.81249 7.2119,15.75196 10.1807,23.87695 2.9687,8.12499 5.5136,16.44239 7.6757,25.00488 2.1621,8.56249 3.9336,17.37403 5.3321,26.49903 1.3984,9.12499 2.4277,18.56153 3.1054,28.37402 0.6778,9.81249 1.0108,20.00489 1.0108,30.62988 0,7.62499 -0.2234,15.13404 -0.6592,22.5293 -0.4358,7.39525 -1.0947,14.667 -1.9629,21.82617 -0.8682,7.15918 -1.9402,14.20628 -3.2373,21.12308 -1.2971,6.9167 -2.8184,13.708 -4.541,20.3759 -1.7227,6.668 -3.656,13.2161 -5.8008,19.629 -2.1448,6.4128 -4.4971,12.6865 -7.0605,18.8378 -2.5635,6.1514 -5.3416,12.178 -8.3203,18.0616 -2.9788,5.8835 -6.1602,11.6318 -9.5508,17.2412 -3.3907,5.6093 -6.9822,11.0774 -10.7813,16.4062 -3.799,5.3289 -7.8076,10.5147 -12.0117,15.5567 -4.2041,5.042 -8.6072,9.9436 -13.2129,14.6924 -4.6057,4.7487 -9.4102,9.3496 -14.4141,13.7988 -5.0039,4.4492 -10.2019,8.7473 -15.6005,12.8906 -5.3987,4.1433 -10.9971,8.1221 -16.7871,11.9531 -5.7901,3.8311 -11.7811,7.5179 -17.959,11.0303 -6.178,3.5125 -12.5391,6.8613 -19.1016,10.0488 -8.625,4.1875 -17.3608,7.9373 -26.1768,11.2647 -8.8159,3.3274 -17.7089,6.2344 -26.6601,8.7158 -8.9512,2.4814 -17.9663,4.532 -26.9971,6.1816 -9.0307,1.6497 -18.0889,2.8887 -27.1435,3.7207 -9.0547,0.8321 -18.106,1.2605 -27.1289,1.2891 z"
        style={{
          fill: "#00ff00",
          fillOpacity: 1,
          stroke: "none",
          strokeOpacity: 1,
        }}
        id="path4"
      />
    </g>
  </svg>
);

// ##### 24-04-05 Komarov
export const WhiteHotels = () => (
  <svg
    data-component="WhiteHotels"
    color="#ffffff"
    width="20"
    height="20"
    aria-hidden="true"
    focusable="false"
    data-prefix="fas"
    data-icon="hotel"
    className="svg-inline--fa fa-hotel fa-w-18"
    role="img"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 576 512"
  >
    {/* ##### 24-08-16 Komarov */}
    <path
      fill="currentColor"
      d="M560 64c8.84 0 16-7.16 16-16V16c0-8.84-7.16-16-16-16H16C7.16 0 0 7.16 0 16v32c0 8.84 7.16 16 16 16h15.98v384H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h240v-80c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v80h240c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16h-16V64h16zm-304 44.8c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v38.4c0 6.4-6.4 12.8-12.8 12.8h-38.4c-6.4 0-12.8-6.4-12.8-12.8v-38.4zm0 96c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v38.4c0 6.4-6.4 12.8-12.8 12.8h-38.4c-6.4 0-12.8-6.4-12.8-12.8v-38.4zm-128-96c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v38.4c0 6.4-6.4 12.8-12.8 12.8h-38.4c-6.4 0-12.8-6.4-12.8-12.8v-38.4zM179.2 256h-38.4c-6.4 0-12.8-6.4-12.8-12.8v-38.4c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v38.4c0 6.4-6.4 12.8-12.8 12.8zM192 384c0-53.02 42.98-96 96-96s96 42.98 96 96H192zm256-140.8c0 6.4-6.4 12.8-12.8 12.8h-38.4c-6.4 0-12.8-6.4-12.8-12.8v-38.4c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v38.4zm0-96c0 6.4-6.4 12.8-12.8 12.8h-38.4c-6.4 0-12.8-6.4-12.8-12.8v-38.4c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v38.4z"
    />
  </svg>
);

export const HotelsObject = {
  name: "Hotels",
  // icon: Hotels()
  icon: <Hotels />,
};
